import { FC } from 'react';
import { cn } from '@new/lib';
import { PAD_LENGTH, PAD_CHAR } from './constants';

interface TimePickerButtonProps {
  value: number;
  selectedValue: string;
  onClick: (value: number) => void;
}

export const TimePickerButton: FC<TimePickerButtonProps> = ({ value, selectedValue, onClick }) => {
  const displayValue = value.toString().padStart(PAD_LENGTH, PAD_CHAR);
  const isSelected = selectedValue === displayValue;

  return (
    <button
      onClick={() => onClick(value)}
      className={cn(
        'w-full px-2 py-1.5 text-sm text-center hover:bg-(--primary-O200) transition-colors cursor-pointer',
        isSelected && 'bg-(--primary-O300) text-(--neutral-white-NW1000)'
      )}
    >
      {displayValue}
    </button>
  );
};
